import EditIntegration from '@/pages/Integrations/Nextbitt/Edit';
import * as React from 'react';
import { createRoot } from 'react-dom/client';

WiseMetering.Views.EditNextbittMaintenanceIntegration = Backbone.Marionette.View.extend({
    id: 'react-container',
    className: 'tailwind-container',

    onShow: function() {
        const integration = this.model ? this.model.toJSON() : {};

        this.reactRoot = createRoot(document.getElementById(this.id));
        this.reactRoot.render(<EditIntegration integration={integration}/>);
    },

    onClose: function() {
        if (this.reactRoot) {
            this.reactRoot.unmount(); // Unmount the React component
            this.reactRoot = null; // Clean up reference
        }
    }
});
